import { motion } from "framer-motion";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Calendar } from "../ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";

const STEP_ANIMATION = {
  initial: { opacity: 0, x: 20 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -20 },
};

export const StepWhenWhere = ({ formData, updateFormData }) => (
  <motion.div key="step1" {...STEP_ANIMATION} className="space-y-6">
    <div className="text-center mb-8">
      <div className="w-16 h-16 bg-[#FF5A1F]/10 mx-auto flex items-center justify-center mb-4">
        <CalendarIcon className="w-8 h-8 text-[#FF5A1F]" />
      </div>
      <h2 className="text-2xl font-['Outfit'] font-bold text-[#0F172A]">When & Where</h2>
      <p className="text-slate-600 mt-2">Tell us about your move dates and locations</p>
    </div>

    <div className="space-y-4">
      <div>
        <Label className="label-text">Move Date *</Label>
        <Popover>
          <PopoverTrigger asChild>
            <Button
              variant="outline"
              className="w-full justify-start text-left font-normal h-12 border-slate-200"
              data-testid="move-date-picker"
            >
              <CalendarIcon className="mr-2 h-4 w-4" />
              {formData.move_date ? format(formData.move_date, "PPP") : "Select date"}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0" align="start">
            <Calendar
              mode="single"
              selected={formData.move_date}
              onSelect={(date) => updateFormData("move_date", date)}
              disabled={(date) => date < new Date()}
              initialFocus
            />
          </PopoverContent>
        </Popover>
      </div>

      <div>
        <Label className="label-text">From Postcode *</Label>
        <Input
          placeholder="e.g. CF10 1AA"
          value={formData.from_postcode}
          onChange={(e) => updateFormData("from_postcode", e.target.value.toUpperCase())}
          className="input-field"
          data-testid="from-postcode-input"
        />
      </div>

      <div>
        <Label className="label-text">To Postcode *</Label>
        <Input
          placeholder="e.g. SW1A 1AA"
          value={formData.to_postcode}
          onChange={(e) => updateFormData("to_postcode", e.target.value.toUpperCase())}
          className="input-field"
          data-testid="to-postcode-input"
        />
      </div>
    </div>
  </motion.div>
);
